import { Location } from "history";
import { useCallback, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

/**
 Makes a callback to redirect to a link, where you bake in any parameters
 i.e.
 const linkToCourse = (courseId) => `/some/path/${courseId}`

 const redirect = useSimpleRedirectCallback(linkToCourse('someCourseId'))

 // No params needed
 navigateToCourse()

 */

type SimpleLink = () => void;

export default function useSimpleRedirectCallback(
  link: string | Location
): SimpleLink {
  const history = useHistory();

  const linkRef = useRef(link);

  useEffect(() => {
    linkRef.current = link;
  }, [link]);

  return useCallback(() => {
    history.replace(linkRef.current as string);
  }, [history]);
}
